export default __webpack_public_path__ + "static/media/img-visionmision-header.757ea06e.jpg";